export default {
  name: 'Name',
  next: 'Next',
  no: 'No',
  nodes: 'Nodes',
  none: 'None'
}
